<template>
  <v-footer id="core-footer" absolute height="82"></v-footer>
</template>

<script>
export default {};
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
